import React from 'react'
import {TbTargetArrow,TbStarFilled} from 'react-icons/tb'
import {HiLightBulb} from 'react-icons/hi'
import { IconContext } from "react-icons";
import { Helmet } from 'react-helmet-async';

function About() {
  return (
    <div>
        <Helmet>
            <title>About StainMasters Ltd</title>
            <meta name="description" content="Providing reliable and regular cleaning services which help the people across 
                    Leicester and Leicestershire.
                        "/>
            <link rel="canonical" href="/about" />
     </Helmet>
    <div class="bg-cover bg-center bg-no-repeat  bg-blend-multiply pt-10">

        <section>
            <div class=" px-4 mx-auto max-w-screen-xl t pt-4">

                <div class="px-4 mx-auto max-w-screen-xl text-center pt-2  ">
                    <h1 class="mt-4 text-3xl font-extrabold tracking-tight leading-none text-navcolour md:text-3xl lg:text-5xl">
                       About US
                    </h1>

                    <p class="px-4  pt-2  font-bold text-navcolour">

                    Here at Stain Masters Ltd we specialise in providing reliable and regular cleaning services which help the people across 
                    Leicester and Leicestershire to maintain their properties and premises with our professional cleaners.. We aim to provide tailored services which suit all our customer requirements. All our cleaners are carefully selected and fully trained as we know that they are the key to the business
We offer regular domestic cleaning services in Leicester either daily, fortnightly, four weekly or as per required.
                    </p>

                    
                </div>

                <div class="md:flex pt-4 pb-4 ">

                    <div class="md:w-1/2  sm:82 rounded-lg   sm:items-center sm:justify-center   mx-2 ">
                        <div class='flex ml-4'>
                        <h5 class=" mb-4 text-2xl font-bold tracking-tight leading-none text-center text-navcolour md:text-3xl lg:text-4xl pt-2">
                           Our Mission <br/><br/>
                        </h5>
                        <IconContext.Provider value={{ color: '#ff7f0f', size: '50px', padding:'1px ' }}>
                            <div class="  sm:items-center sm:justify-center    mb-4">
                              <TbTargetArrow class="sm:items-center sm:justify-center  "/>
                            </div>
                          </IconContext.Provider>
                       </div>

                        <p class="pl-4 font-normal text-navcolour text-sm md:text-lg">
                        
                        StainMasters aims to make a noticeable difference to the people we serve, the places we clean, the communities we operate and the people we employ

.


                        <br/><br/>

                        </p>

                    </div>

                    <div class="md:w-1/2  sm:82 rounded-lg   sm:items-center sm:justify-center   mx-2 ">
                        <div class='flex ml-4'>
                        <h5 class=" mb-4 text-2xl font-bold tracking-tight leading-none text-center text-navcolour md:text-3xl lg:text-4xl pt-2">
                           Our Vision <br/><br/>
                        </h5>
                        <IconContext.Provider value={{ color: '#ff7f0f', size: '50px', padding:'1px ' }}>
                            <div class="  sm:items-center sm:justify-center    mb-4">
                              <HiLightBulb class="sm:items-center sm:justify-center  "/>
                            </div>
                          </IconContext.Provider>
                       </div>

                        <p class="pl-4 font-normal text-navcolour text-sm md:text-lg">
                        
                        To become a vibrant industy player that provides a clean and healthy space for our 
                        client's homes and business premises. To also build long lasting relationships with 
                        our clients and maintain our high level if integrity and professionalism.


                        <br/><br/>

                        </p>

                    </div>

                </div>

                <div class="md:flex pt-4 pb-4">

                     

                    <div class="md:w-full  sm:82 rounded-lg  sm:items-center sm:justify-center   mx-2 ">
                        <h5 class="mx-auto mb-4 text-2xl font-bold tracking-tight leading-none text-center text-navcolour md:text-3xl lg:text-5xl pt-2">
                           Our Values <br/><br/>
                        </h5>
                        <div class="  grid  lg:grid-cols-2 lg:gap-x-3 m-auto md:grid-cols-2 md:gap-x-2 grid-col-1 px-2 item-stretch ">
                       
                            <div class='flex col-span-1'>
                                <IconContext.Provider value={{ color: '#ff7f0f', size: '50px', padding:'1px ' }}>
                                    <div class="  sm:items-center sm:justify-center    mb-4">
                                    <TbStarFilled class="sm:items-center sm:justify-center  "/>
                                    </div>
                                </IconContext.Provider>
                            

                                <p class="pl-4 font-medium text-navcolour text-sm md:text-lg">
                                
                                <b>Integrity -</b> When no one is supervising, we still do the right thing
.

                                <br/><br/>

                                </p>

                            </div>

                            <div class='flex col-span-1'>
                                <IconContext.Provider value={{ color: '#ff7f0f', size: '50px', padding:'1px ' }}>
                                    <div class="  sm:items-center sm:justify-center    mb-4">
                                    <TbStarFilled class="sm:items-center sm:justify-center  "/>
                                    </div>
                                </IconContext.Provider>
                            
                                <p class="pl-4 font-medium text-navcolour text-sm md:text-lg">
                                
                                <b>Professionalism -</b> We strive to deliver the best tailored cleaning service
.

                                <br/><br/>

                                </p>


                            </div>

                            <div class='flex col-span-1'>
                                <IconContext.Provider value={{ color: '#ff7f0f', size: '50px', padding:'1px ' }}>
                                    <div class="  sm:items-center sm:justify-center    mb-4">
                                    <TbStarFilled class="sm:items-center sm:justify-center  "/>
                                    </div>
                                </IconContext.Provider>
                            
                                <p class="pl-4 font-medium text-navcolour text-sm md:text-lg">
                                
                                <b>Community impact -</b> Building long lasting relationships with our clients

.

                                <br/><br/>

                                </p>

                            </div>

                            <div class='flex col-span-1'>
                                <IconContext.Provider value={{ color: '#ff7f0f', size: '50px', padding:'1px ' }}>
                                    <div class="  sm:items-center sm:justify-center    mb-4">
                                    <TbStarFilled class="sm:items-center sm:justify-center  "/>
                                    </div>
                                </IconContext.Provider>
                            
                                <p class="pl-4  text-navcolour font-medium text-sm md:text-lg">
                                
                                <b>Commitment -</b> Our passion and persistence drives us to reach greater heights.

                                <br/><br/>

                                </p>

                            </div>

                            <div class='flex col-span-1'>
                                <IconContext.Provider value={{ color: '#ff7f0f', size: '50px', padding:'1px ' }}>
                                    <div class="  sm:items-center sm:justify-center    mb-4">
                                    <TbStarFilled class="sm:items-center sm:justify-center  "/>
                                    </div>
                                </IconContext.Provider>
                            
                                <p class="pl-4  text-navcolour font-medium text-sm md:text-lg">
                                
                                <b>Loyalty -</b> we maintain strong connections with customers and staff.

                                <br/><br/>

                                </p>

                            </div>
                        </div>
                        
                    </div> 

                </div>

            </div>
      </section> 
        </div></div>
  )
}

export default About